import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/dms/drawing-revs`;

/** Blob で返ってきたエラー応答から、サーバーの理由とHTTP状態を取り出す。 */
async function readBlobError(e) {
  const status = e?.response?.status;
  let detail = null;
  const body = e?.response?.data;
  try {
    if (body instanceof Blob) {
      const text = await body.text();
      try { detail = JSON.parse(text)?.detail; } catch { detail = text.slice(0, 200); }
    } else if (typeof body === 'string') {
      detail = body.slice(0, 200);
    } else if (body?.detail) {
      detail = body.detail;
    }
  } catch { /* 読めなければ状態だけ伝える */ }
  if (!detail && !status) detail = 'サーバーに届きませんでした（通信が切れた可能性があります）';
  const err = new Error(detail || `サーバーが ${status} を返しました`);
  err.status = status;
  err.detail = detail;
  return err;
}

export const drawingRevApi = {
  scan: (params = {}) => axios.post(`${API}/scan`, {}, { params }).then((r) => r.data),
  families: (params = {}) => axios.get(`${API}/families`, { params }).then((r) => r.data),
  family: (key) => axios.get(`${API}/families/${encodeURIComponent(key)}`).then((r) => r.data),
  confirmLatest: (key, documentId) =>
    axios.post(`${API}/families/${encodeURIComponent(key)}/confirm-latest`,
      { document_id: documentId }).then((r) => r.data),
  unconfirmLatest: (key) =>
    axios.delete(`${API}/families/${encodeURIComponent(key)}/confirm-latest`).then((r) => r.data),
  patchRevision: (did, body) => axios.patch(`${API}/documents/${did}`, body).then((r) => r.data),
  unassigned: (params = {}) => axios.get(`${API}/unassigned`, { params }).then((r) => r.data),
  context: (did) => axios.get(`${API}/documents/${did}/context`).then((r) => r.data),
  pageImage: async (did, scale = 1.6, { maxEdge } = {}) => {
    try {
      const r = await axios.get(`${API}/documents/${did}/page-image`,
        { params: { scale, ...(maxEdge ? { max_edge: maxEdge } : {}) }, responseType: 'blob' });
      return URL.createObjectURL(r.data);
    } catch (e) {
      // responseType が blob のときは、サーバーのエラーJSONも Blob で届く。
      // そのため `e.response.data.detail` は常に undefined になり、
      // 画面には理由の無い既定文だけが出てしまう。ここで中身を読んで返す。
      throw await readBlobError(e);
    }
  },
  setSuffixRule: (key, rule) =>
    axios.post(`${API}/families/${encodeURIComponent(key)}/suffix-rule`, { rule })
      .then((r) => r.data),
  splitOut: (key, documentIds) =>
    axios.post(`${API}/families/${encodeURIComponent(key)}/split`,
      { document_ids: documentIds }).then((r) => r.data),
  moveFamily: (did, drawingNoKey) =>
    axios.post(`${API}/documents/${did}/move-family`,
      { drawing_no_key: drawingNoKey }).then((r) => r.data),
  clearFamilyOverride: (did) =>
    axios.delete(`${API}/documents/${did}/family-override`).then((r) => r.data),
  diff: (params) => axios.get(`${API}/diff`, { params }).then((r) => r.data),
  align: (params) => axios.get(`${API}/align`, { params }).then((r) => r.data),
  fieldLabels: () => axios.get(`${API}/field-labels`).then((r) => r.data),
  patchFields: (did, fields) =>
    axios.patch(`${API}/documents/${did}/fields`, { fields }).then((r) => r.data),
  similar: (did, params = {}) =>
    axios.get(`${API}/similar/${did}`, { params }).then((r) => r.data),
  splitCandidates: () => axios.get(`${API}/split-candidates`).then((r) => r.data),
  splitProposal: (did) =>
    axios.get(`${API}/documents/${did}/split-proposal`).then((r) => r.data),
  split: (did, parts) =>
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/dms/documents/${did}/split`,
      { parts }).then((r) => r.data),
};

export const CONFIDENCE_META = {
  high:      { label: '図面から読取', cls: 'bg-teal-50 text-teal-700 border-teal-200', mark: '✓' },
  uncertain: { label: '推測（要確認）', cls: 'bg-amber-50 text-amber-800 border-amber-300', mark: '?' },
  manual:    { label: '人が入力', cls: 'bg-zinc-100 text-zinc-700 border-zinc-300', mark: '✎' },
};

export default drawingRevApi;
